import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

const SIZE_MAP = {
  sm: "sm:max-w-md",
  md: "sm:max-w-lg",
  lg: "sm:max-w-2xl",
  xl: "sm:max-w-4xl",
  "2xl": "sm:max-w-5xl",
};

const AppDialog = ({
  open,
  onOpenChange,
  title,
  description,
  icon: Icon,
  header,
  size = "md",
  children,
  footer,
  contentClassName = "",
  headerWrapperClassName = "",
  headerClassName = "",
  bodyClassName = "",
  footerClassName = "",
  closeButtonClassName = "",
  hideCloseButton = false,
  lockClose = false,
}) => {
  const sizeClass = SIZE_MAP[size] || SIZE_MAP.md;

  const handleInteractOutside = (event) => {
    if (lockClose) {
      event.preventDefault();
    }
  };

  const handleEscapeKeyDown = (event) => {
    if (lockClose) {
      event.preventDefault();
    }
  };

  const headerContent =
    header !== undefined ? (
      header
    ) : title ? (
      <div className="flex items-start gap-3">
        {Icon ? (
          <span className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Icon className="h-5 w-5" />
          </span>
        ) : null}
        <div>
          <DialogTitle className="text-xl font-semibold text-foreground text-primary">
            {title}
          </DialogTitle>
          {description ? (
            <DialogDescription className="text-sm text-muted-foreground">
              {description}
            </DialogDescription>
          ) : null}
        </div>
      </div>
    ) : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        onInteractOutside={handleInteractOutside}
        onEscapeKeyDown={handleEscapeKeyDown}
        className={cn(
          "w-full border border-border bg-card p-4 sm:rounded-radius",
          "max-h-[85vh] overflow-hidden",
          "flex flex-col",
          sizeClass,
          contentClassName,
        )}
      >
        <div
          className={cn(
            "flex items-start justify-between gap-4 pb-3 border-b border-border",
            headerWrapperClassName,
          )}
        >
          <DialogHeader
            className={cn("flex-1 gap-2 text-left", headerClassName)}
          >
            {headerContent}
          </DialogHeader>
          {!hideCloseButton ? (
            <DialogClose
              className={cn(
                "inline-flex h-9 w-9 items-center justify-center text-muted-foreground transition hover:text-foreground",
                closeButtonClassName,
              )}
            >
              <X className="h-5 w-5" strokeWidth={2} />
              <span className="sr-only">Close</span>
            </DialogClose>
          ) : null}
        </div>

        {children ? (
          <div
            className={cn(
              "min-h-0 flex-1 flex flex-col overflow-y-auto gap-y-6 !py-3 !px-0",
              bodyClassName,
            )}
          >
            {children}
          </div>
        ) : null}

        {footer ? (
          <div className="">
            <div className="mb-4 h-px bg-border" />
            <DialogFooter className={cn("", footerClassName)}>
              {footer}
            </DialogFooter>
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default AppDialog;
